export enum DialogType {
    DEFAULT = 'default',
    DELETE_VEHICLE = 'delete_vehicle',
    DELETE_CLIENT = 'delete_client',
    DELETE_ALARM = 'delete_alarm',
    DELETE_PHOTO = 'delete_photo',
    DELETE_PACKAGE = 'delete_package',
    DELETE_REPEATER_ITEM = 'delete_repeater_item',
    REMOVE_USER_FROM_ACCOUNT = 'remove_user_from_account',
    REMOVE_EXPENSE = 'remove_expense',
    REMOVE_AD = 'remove_ad',
    DISABLE_ADVERTISING = 'disable_advertising',
    UNPUBLISH_ALL_ADS = 'unpublish_all_ads',
    CREATE_DOCUMENT = 'create_document',
    CREATE_COMMISSION_DOCUMENT = 'create_commission_document',
    ARCHIVE_VEHICLE = 'archive_vehicle',
    UNARCHIVE_VEHICLE = 'unarchive_vehicle',
    REMOVE_PAYMENT = 'remove_payment',
    REMOVE_INVOICE_DOCUMENT = 'remove_invoice_document',
    UNCANCEL_INVOICE_DOCUMENT = 'uncancel_invoice_document',
    REMOVE_INVOICE_ASSET_DOCUMENT = 'cancel_invoice_asset_document',
    ARCHIVE_DOCUMENT = 'archive_document',
    UNARCHIVE_DOCUMENT = 'unarchive_document',
    REMOVE_ENTITY_GROUP = 'remove_entity_group',
    UPDATE_DOCUMENT = 'update_document',
    DELETE_NLB_DRAFT = 'delete_nlb_draft',
    REMOVE_CASH_RECEIPT = 'remove_cash_receipt',
    REACTIVATE_ACCOUNT = 'reactivate_account',
    CHANGE_BUSINESS_UNIT = 'change_business_unit',
    ARCHIVE_ASSET = 'archive_asset',
    UNARCHIVE_ASSET = 'unarchive_asset',
    DELETE_BUSINESS_UNIT = 'delete_business_unit',
    RESUBSCRIBE = 'resubscribe',
    PUBLISH_TO_TRADING_HUB = 'publish_to_trading_hub',
    APPROVE_BID = 'approve_bid',
    REJECT_BID = 'reject_bid',
    RESCHEDULE_AUCTIONS  = 'reschedule_auctions',
    EXTEND_AUCTIONS  = 'extend_auctions',
    FISCALIZATION_SETUP_WARNING = 'fiscalization_setup_warning',
    VEHICLE_HAS_ACTIVE_ADVANCE = 'vehicle_has_active_advance',
    REMOVE_ALL_SITE_ASSIGNMENTS = 'remove_all_site_assignments',
    DEACTIVATE_MODULE_PACKAGE = 'deactivate_module_package',
    // Arrears-billed (standalone/PAYG) modules: access ends immediately, only the
    // days used are invoiced. See BRIEFD-7150.
    DEACTIVATE_MODULE_PACKAGE_IMMEDIATE = 'deactivate_module_package_immediate',
    LOGGED_IN_USER_WARNING = 'logged_in_user_warning',
    /** BRIEFD-7315: generic "you have unsaved form changes" guard — used by
     *  the route-level unsaved-changes guard (covers in-app navigation and
     *  the browser back button) and by the AI description "regenerate"
     *  button (which isn't a navigation at all, so the guard never fires
     *  for it). */
    DISCARD_UNSAVED_CHANGES = 'discard_unsaved_changes',
}
